/**
 * The prefix used for keys in the local storage to ensure uniqueness.
 */
const storagePrefix = 'techem_direct_';

/**
 * Enum representing the keys for A/B testing values in the local storage.
 */
export enum StorageKey {
  ABTesting = 'ab_testing_'
}

/**
 * Object with functions to set and get A/B testing values in the local storage.
 */
const Storage = {
  /**
   * Sets the specified A/B testing value in the local storage.
   *
   * @param {string} forKey - The key for the A/B testing value to be stored.
   * @param {string} value - The value to be stored for the specified key.
   */
  setABTestingValue: (forKey: string, value: string) => {
    window.localStorage.setItem(
      `${storagePrefix}${StorageKey.ABTesting}${forKey}`,
      JSON.stringify(value)
    );
  },

  /**
   * Retrieves the A/B testing value for the specified key from the local storage.
   *
   * @param {string} forKey - The key for the A/B testing value to be retrieved.
   * @returns {any} - The retrieved A/B testing value, or null if not found in the local storage.
   */
  getABTestingValue: (forKey: string) => {
    const storedValue = window.localStorage.getItem(
      `${storagePrefix}${StorageKey.ABTesting}${forKey}`
    );
    return storedValue ? JSON.parse(storedValue) : null;
  }
};

export default Storage;
